import React, { Component } from 'react'
import Jumbotron from "react-bootstrap/Jumbotron";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import "./contact.style.css";

 class ContactMe extends Component {
    render() {
        return (
         <div id="contact">
            <h1 className="pt-3 text-center font-details-b pb-3">CONTACT ME</h1>
            <Jumbotron className="contact-jumbotron">
              <Row>
                <Col className="d-flex justify-content-center flex-wrap">
                  <div className="m-2">
                    <a href="mailto:abbas.derawall@gmail.com" target="_blank" rel="noopener noreferrer">
                      <Button variant="outline-danger" title="abbas.derawall@gmail.com">
                        <i className="fas fa-envelope-square"></i> Email Me
                      </Button>
                    </a>
                  </div>
                  <div className="m-2">
                    <a href="tel:+923460777050" target="_blank" rel="noopener noreferrer">
                      <Button variant="outline-secondary" title="+92 346 0777050">
                        <i className="fas fa-phone-square"></i> Phone
                      </Button>
                    </a>
                  </div>
                  <div className="m-2">
                    <a href="https://abbasderawall.com" target="_blank" rel="noopener noreferrer">
                      <Button variant="outline-success" title="abbasderawall.com">
                        <i className="fas fa-globe"></i> Website
                      </Button>
                    </a>
                  </div>
                  <div className="m-2">
                    <a href="https://www.linkedin.com/in/muhammad-abbas-khan/" target="_blank" rel="noopener noreferrer">
                      <Button variant="outline-primary" title="Visit my LinkenIn">
                        <i className="fab fa-linkedin"></i> LinkedIn
                      </Button>
                    </a>
                  </div>
                  
                  <div className="m-2">
                    <a href="https://github.com/abbasderawall/" target="_blank" rel="noopener noreferrer">
                      <Button variant="outline-dark" title="My other projects">
                        <i className="fab fa-github-square"></i> GitHub
                      </Button>
                    </a>
                  </div>
               
                  <div className="m-2">
                    <a href="https://twitter.com/AbbasDerawall" target="_blank" rel="noopener noreferrer">
                      <Button variant="outline-info" title="Tweets are welcomed!">
                        <i className="fab fa-twitter"></i> Twitter
                      </Button>
                    </a>
                  </div>
                  <div className="m-2">
                    <a href="https://www.facebook.com/abbas.derawall" target="_blank" rel="noopener noreferrer">
                      <Button variant="outline-primary" title="Say hello on FB">
                        <i className="fab fa-facebook-square"></i> FaceBook
                      </Button>
                    </a>
                  </div>
                </Col>
              </Row>
            </Jumbotron>
          </div>
        )
    }
}

export default ContactMe
